import { config } from '../config';
import { RndApi } from '@kilornd/api-wrapper/dist';

export const Api = new RndApi(config.BASE_URL, config.API_TOKEN);
